import React from "react";
import ReactDOM from "react-dom";
import env from "./env";
import { startMirageServer } from "./setupDevEnv";
import BaseProvider, { Logger } from "@base-provider";
import { reducers } from "./redux/reducers";
import { translations } from "./languages";
import App from "./App";
import { ThemeProvider } from "@sf-core";
import "@sf-core/assets/css/index.scss";
import { API_PARAMS } from "./constants/apiParams";

Logger.of("App.Environment").info(env);

if (env.REACT_APP_ENABLE_MOCK_API) {
  startMirageServer();
}

ReactDOM.render(
  <React.StrictMode>
    <BaseProvider
      config={{
        reducers,
        translations,
        themeProvider: ThemeProvider,
        apiEndpoints: {
          base: env.REACT_APP_API_ENDPOINT,
          identityCurrent: API_PARAMS.IDENTITY_CURRENT,
        },
        appInsights: {
          enable: env.REACT_APP_ENABLE_APPLICATION_INSIGHTS,
          instrumentationKey: env.REACT_APP_APPINSIGHTS_INSTRUMENTATIONKEY,
        },
        auth0Config: {
          auth: {
            clientId: env.REACT_APP_AUTH0_CLIENT_ID,
            domain: env.REACT_APP_AUTH0_DOMAIN,
            scope: env.REACT_APP_AUTH0_SCOPE,
            audience: env.REACT_APP_AUTH0_AUDIENCE,
          }
        },
        forceTenant: env.REACT_APP_FORCE_TENANT,
        persistStoreKey: "web-admin",
        appName: "Admin",
        authInstance: env.REACT_APP_AUTH_INSTANCE,
      }}
    >
      <App />
    </BaseProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
